const ChartData = [
    {
        month: "Mar",
        investment: 100000,
        sell: 241,
        loss:234,
        revenue: 10401,
    },
    {
        month: "Apr",
        investment: 200000,
        sell: 423,
        loss:234,
        revenue: 24500
    },
    {
        month: "May",
        investment: 500000,
        sell: 726,
        loss:234,
        revenue: 67010
    },
    {
        month: "Jun",
        investment: 500000,
        sell: 529,
        loss:234,
        revenue: 40405
    },
    {
        month: "Jul",
        investment: 600000,
        sell: 601,
        loss:234,
        revenue: 50900
    },
    {
        month: "Aug",
        investment: 700000,
        sell: 670,
        loss:234,
        revenue: 61000
    }
]

export default ChartData;